module.exports = __webpack_public_path__ + "img/coffee-cup.a9635f18.svg";